import React, { useState, createContext, useEffect } from "react";
import * as Storage from "ts-storage";

export const CartContext = createContext<any>([]);

const CartProvider: React.FC<{ children: any }> = ({ children }) => {
  const [cart, setCart] = useState<Array<string>>([]);

  useEffect(() => {
    let fallback: string = "nothing";
    let cartFromStorage: any = Storage.get("cart", fallback).value;
    if (cartFromStorage === fallback) {
      Storage.set("cart", JSON.stringify([]));
    } else {
      setCart(JSON.parse(cartFromStorage));
    }
  }, []);

  return (
    <CartContext.Provider value={[cart, setCart]}>
      {children}
    </CartContext.Provider>
  );
};

export default CartProvider;
